import { Product } from '@Types/product.types';
import { User } from '@Types/user.types';
import { getValue } from '@Selectors';
import { internalEmailDomains } from '@innovyze/shared-utils';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const internalEmailDomainsSet = new Set(internalEmailDomains);

export const getFilteredUsers = (users: User[], isExternal?: boolean) => {
	const filteredUsers = users.filter(user => {
		const { username: email } = user;
		const domain = email.split('@')[1];
		return isExternal
			? !internalEmailDomainsSet.has(domain)
			: internalEmailDomainsSet.has(domain);
	});
	return filteredUsers;
};

export const validateUsersLimit = (
	subscribedUserIds: string[],
	product?: Product,
	externalUsers?: User[],
) => {
	const externalUsersUsed =
		externalUsers?.filter(el => subscribedUserIds.includes(el.id)) || [];
	const numberOfSubscriptionsUsed =
		(externalUsersUsed
			? externalUsersUsed?.length
			: product?.numberOfEntitlementsUsed) || 0;
	const maxSubscriptions = product?.numberOfEntitlements || 0;

	const limitReached = !!(
		numberOfSubscriptionsUsed &&
		numberOfSubscriptionsUsed >= maxSubscriptions
	);
	const limitSurpassed = !!(
		numberOfSubscriptionsUsed &&
		numberOfSubscriptionsUsed > maxSubscriptions
	);

	return {
		limitReached,
		limitSurpassed,
	};
};

export const useGetInternalUsersFromPaginated = () => {
	const { users } = useSelector(getValue).users.paginatedUsers;
	const [internalUsers, setInternalUsers] = useState<User[]>([]);
	useEffect(() => {
		if (users) {
			setInternalUsers(getFilteredUsers(users, false));
		}
	}, [users]);
	return internalUsers;
};

export const useGetExternalUsersFromPaginated = () => {
	const { users } = useSelector(getValue).users.paginatedUsers;
	const [externalUsers, setExternalUsers] = useState<User[]>([]);
	useEffect(() => {
		if (users) {
			setExternalUsers(getFilteredUsers(users, true));
		}
	}, [users]);
	return externalUsers;
};
